// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Box, Icon } from 'gestalt';

type Props = {|
  // TODO @cvuerings combine sections + sections inline (once we get rid of the repin modal)
  type: 'group' | 'protected' | 'secret' | 'sections' | 'sectionsInline',
|};

export function BoardPickerRowIcon({ type }: Props) {
  const typeToIconMapping = {
    group: {
      accessibilityLabel: i18n._('group board', 'Board picker group board icon'),
      icon: 'people',
    },
    protected: {
      accessibilityLabel: i18n._('protected board', 'Board picker protected board icon'),
      icon: 'lock',
    },
    secret: {
      accessibilityLabel: i18n._('secret board', 'Board picker secret board icon'),
      icon: 'lock',
    },
    sections: {
      accessibilityLabel: i18n._('board with sections', 'Board picker board with sections icon'),
      icon: 'arrow-forward',
    },
    sectionsInline: {
      accessibilityLabel: i18n._('board with sections', 'Board picker board with sections icon'),
      icon: 'arrow-down',
    },
  };

  const item = typeToIconMapping[type];

  return (
    <Box marginLeft={1}>
      <Box marginStart={2}>
        {type === 'sections' || type === 'sectionsInline' ? (
          <Icon
            accessibilityLabel={item.accessibilityLabel}
            icon={item.icon}
            size="12"
            color="darkGray"
          />
        ) : (
          <Icon
            accessibilityLabel={item.accessibilityLabel}
            icon={item.icon}
            size={16}
            color="darkGray"
          />
        )}
      </Box>
    </Box>
  );
}

export default BoardPickerRowIcon;
